<template>
  <div class="w-100 m-0 pl-4 pl-md-7 pr-3 pr-md-5 pr-lg-6 pr-xl-9">

        <b-navbar toggleable="lg" type="dark" class="px-0 round_corners" :class="navbarClass">
          <b-navbar-brand class="px-3 px-lg-0" to="/">
            <img class="d-none d-lg-block" src="~@/assets/img/logo.svg" alt="logo" width="150px" height="52px">
            <img v-if="menuOpened" class="d-block d-lg-none" src="~@/assets/img/logo.svg" alt="logo" width="94.44px" height="32px">
            <img v-else class="d-block d-lg-none" src="~@/assets/img/logo_p.svg" alt="logo" width="94.44px" height="32px">
          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse" class="border-0">
            <template v-slot:default="{ expanded }">
              <div id="menu_burger" :class="expanded ? 'open' : ''">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </template>
          </b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <b-nav-item to="/product" class="menu_item ml-0 mt-2 mt-lg-0 py-1 py-lg-0 px-3 px-lg-0">Product</b-nav-item>

              <div @mouseover="showDevelopers(true)" @mouseleave="showDevelopers(false)">
                <b-nav-item-dropdown text="Developers" right no-caret ref="dropdownDevelopers" class="menu_item ml-0 ml-lg-3 py-1 py-lg-0 px-3 px-lg-0">
                  <b-dropdown-item href="https://docs.amio.io" target="_blank">
                    <div class="d-inline-block mr-3 my-1"><img src="~@/assets/img/ic_docu.svg" width="32px" height="26px"></div>
                    <span>Documentation</span>
                  </b-dropdown-item>
                  <b-dropdown-item href="https://docs.amio.io/v1.0/reference" target="_blank">
                    <div class="d-inline-block mr-3 my-1"><img src="~@/assets/img/ic_api.svg" width="32px" height="26px"></div>
                    <span>API Reference</span>
                  </b-dropdown-item>
                  <b-dropdown-item href="https://github.com/amio-io/amio" target="_blank">
                    <div class="d-inline-block mr-3 my-1"><img src="~@/assets/img/icons/sdk.svg" width="32px" height="26px"></div>
                    <span>SDKs</span>
                  </b-dropdown-item>
                  <b-dropdown-item href="https://status.amio.io" target="_blank">
                    <div class="d-inline-block mr-3 my-1"><img src="~@/assets/img/ic_status.svg" width="32px" height="26px"></div>
                    <span>Status</span>
                  </b-dropdown-item>
                </b-nav-item-dropdown>
              </div>

              <div @mouseover="showCompany(true)" @mouseleave="showCompany(false)">
                <b-nav-item-dropdown text="Company" right no-caret ref="dropdownCompany" class="menu_item ml-0 ml-lg-3 py-1 py-lg-0 px-3 px-lg-0">
                  <b-dropdown-item href="https://blog.amio.io" target="_blank">
                    <div class="d-inline-block mr-3 my-1"><img src="~@/assets/img/blog.svg" width="32px" height="26px"></div>
                    <span>Blog</span>
                  </b-dropdown-item>
                  <b-dropdown-item href="mailto:support@amio.io" target="_blank">
                    <div class="d-inline-block mr-3 my-1"><img src="~@/assets/img/contact.svg" width="32px" height="26px"></div>
                    <span>Contact</span>
                  </b-dropdown-item>
                </b-nav-item-dropdown>
              </div>

              <div class="menu_divider d-none d-lg-inline-block ml-3"></div>

              <b-nav-item href="https://automate.amio.io/login" class="menu_item ml-0 ml-lg-3 py-1 py-lg-0 px-3 px-lg-0" id="menu_login">
                <div class="d-none d-lg-inline-block">
                  <img src="~@/assets/img/login_icon.svg" alt="login" width="16px" height="16px">
                </div>
                Log In
              </b-nav-item>

              <b-nav-item id="menu_demo" class="menu_button ml-0 ml-lg-5 py-1 py-lg-0 px-3" href="" onclick="Calendly.initPopupWidget({url: 'https://calendly.com/matous-kucera/30min'});return false;">
                  Book a demo
              </b-nav-item>

            </b-navbar-nav>
          </b-collapse>
        </b-navbar>

  </div>
</template>

<script>
  import analyticsMixin from '@/mixins/analytics.mixin'

  export default {
    mixins: [analyticsMixin],

    data() {
      return {
        menuOpened: false,
        navbarClass: 'bg-transparent'
      }
    },

    methods: {
      trackSignup: function () {
        this.trackSignup()
      },
      showDevelopers(hovered) {
        if (hovered) {
          this.$refs.dropdownDevelopers.show()
        } else {
          this.$refs.dropdownDevelopers.hide()
        }
      },
      showCompany(hovered) {
        if (hovered) {
          this.$refs.dropdownCompany.show()
        } else {
          this.$refs.dropdownCompany.hide()
        }
      }
    },
    watch: {
      menuOpened() {
        if (this.menuOpened) {
          this.navbarClass = 'bg-white menu_shadow'
        } else {
          this.navbarClass = 'bg-transparent'
        }
      }
    },

    mounted() {
      this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
        if (collapseId === 'nav-collapse') {
          this.menuOpened = isJustShown
        }
      })
    }
  }
</script>

<style lang="scss">
  /* workaround to make the no-caret parameter work
    https://github.com/bootstrap-vue/bootstrap-vue/issues/2951
  */
  @import '../../scss/main';
  @import '~bootstrap-vue/src/index';

  .menu_divider{
    width: 1px;
    height: 1.2em;
    background-color: #fff;
    position: relative;
    top: 12px;
  }

  @media (min-width: map-get($grid-breakpoints, "lg")) {
    .menu_button  {
      border: 2px solid #3dcf90;
      font-weight: 700;
      font-size: 0.9em;
      background: none transparent !important;
      padding: 0 20px !important;
      border-radius: 50px;
      display: inline-block;
    }
    .menu_button:hover {
      background-color: #3dcf90 !important;
    }

    .menu_item.show > a.dropdown-toggle ::before{
      border-color: white transparent;
      border-style: solid;
      border-width: 0px 13px 13px 13px;
      border-radius: 3px;
      height: 0px;
      width: 0px;
      content: '';
      position: absolute;
      margin-left: 30px;
      margin-top: 28px;
      opacity: 1 !important;
    }

    .menu_item .dropdown-menu {
      border-color: white transparent;
      border-radius: 5px;
      box-shadow: 0 10px 20px rgba(0,0,0,.15);
    }

    .menu_item .dropdown-item.active, .menu_item  .dropdown-item:active {
      background-color: rgba(111, 64, 255, 0.5);
    }
  }

  .menu_button  {
    background-color: #3dcf90;
    font-weight: 700;
    font-size: 0.9em;
    display: inline-block;
  }

  .menu_button > .nav-link {
    color: #3dcf90 !important;
  }

  .menu_button:hover .nav-link {
    color: #fff !important;
  }

  .menu_item > .nav-link {
    color: #fff !important;
    outline: none;
  }

  .menu_item:hover .nav-link {
    color: #C7B7FF !important;
  }

  #nav-collapse.show {
    background-color: #fff;
  }

  #nav-collapse.show .nav-link{
    color: #000  !important;
  }

  #nav-collapse.show #menu_demo > .nav-link{
    color: #fff  !important;
  }

  #nav-collapse.show #menu_login{
    background-color: #eff2f6;
  }

  #nav-collapse.show .dropdown-menu{
    border: none !important;
  }

  .round_corners {
    border-radius: 10px;
  }

  .menu_shadow {
    box-shadow: 0 5px 11px -3px rgba(0,0,0,0.61);
  }

  #menu_burger {
    margin-top: 20px;
    width: 30px;
    height: 22px;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .5s ease-in-out;
    -moz-transition: .5s ease-in-out;
    -o-transition: .5s ease-in-out;
    transition: .5s ease-in-out;
    cursor: pointer;
  }

  #menu_burger span {
    display: block;
    position: absolute;
    height: 3px;
    width: 100%;
    background: #fff;
    border-radius: 10px;
    opacity: 1;
    left: 0;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .25s ease-in-out;
    -moz-transition: .25s ease-in-out;
    -o-transition: .25s ease-in-out;
    transition: .25s ease-in-out;
  }

  #menu_burger.open {
    transform: scale(0.8, 0.8);
    transform-origin: bottom center;
  }

  #menu_burger.open span {
    background: #6e40ff;
  }

  #menu_burger span:nth-child(1) {
    top: 0px;
  }

  #menu_burger span:nth-child(2), #menu_burger span:nth-child(3) {
    top: 9px;
  }

  #menu_burger span:nth-child(4) {
    top: 18px;
  }

  #menu_burger.open span:nth-child(1) {
    top: 9px;
    width: 0%;
    left: 50%;
  }

  #menu_burger.open span:nth-child(2) {
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  #menu_burger.open span:nth-child(3) {
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }

  #menu_burger.open span:nth-child(4) {
    top: 9px;
    width: 0%;
    left: 50%;
  }

</style>
